export default () => ({
  total: 0,
  seal_certificate: null,
})
